import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ClasseFabbricato } from 'src/app/models/classe-fabbricato';
import { BaseEditForm } from 'src/app/shared/baseEditForm';


@Component({
  selector: 'classi-fabbricato-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class ClassiFabbricatoFormComponent extends BaseEditForm implements OnInit {

  classeFabbricato: ClasseFabbricato;
  form: FormGroup;
  constructor(private fb: FormBuilder,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<ClassiFabbricatoFormComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: ClasseFabbricato,) {
    super();
    this.classeFabbricato = data;
  }

  ngOnInit() {

    this.form = this.fb.group({
      nome: [this.classeFabbricato?.nome, Validators.required],
    });
  }

}

